import './Dropzone.scss';
import { useTranslation } from 'react-i18next';
import { ReactComponent as FileDragAndDropIcon } from 'images/icons/FileDragAndDrop.svg';
import { useState } from 'react';
import { useDropzone } from 'react-dropzone';
import ErrorInfo from 'components/ErrorInfo/ErrorInfo';

export const Dropzone = ({ handleDataExtraction }: { handleDataExtraction: (files: any) => void }) => {
  const { t } = useTranslation();
  const [uploadedFileError, setUploadedFileError] = useState<string>('');

  const { fileRejections, getRootProps, getInputProps } = useDropzone({
    accept: ['text/csv', '.csv'],
    onDrop: (acceptedFiles) => {
      setUploadedFileError('');
      if (acceptedFiles.length) {
        handleDataExtraction(acceptedFiles[0]);
      }
    },
  });

  return (
    <>
      <div {...getRootProps({ className: 'dropzone' })}>
        <input {...getInputProps()} />
        <FileDragAndDropIcon />
        <span>{t('DragAndDrop', { ns: 'studentsPage' })}</span>
        <span>
          <>{t('DragAndDropHint', { ns: 'studentsPage' })}</>
        </span>
      </div>
      {uploadedFileError !== '' ? <ErrorInfo errorMsg={uploadedFileError} /> : null}
    </>
  );
};
